module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "section__subtitle-container--invisible section__subtitle-container"
  }, [_vm._t("subtitle")], 2), _vm._v(" "), _vm._t("issues"), _vm._v(" "), _vm._t("credits"), _vm._v(" "), _vm._t("related-posts"), _vm._v(" "), _vm._t("projects"), _vm._v(" "), _vm._t("fbcomments")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38b167e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Description.vue
// module id = 112
// module chunks = 1